import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import BlockingSpinnerOverlay from 'components/BlockingSpinnerOverlay';
import { Button, Row, Col } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { registrationSteps } from "../PreSignUp";
import identityClient from 'clients/identityClient';
import { WORKFLOW_TYPE_LINK_ACCOUNT } from 'helpers/registrationWorkflow';
import { isMobileNumberRequiredForLinking } from 'helpers/customBranding';
import HpaStoreContext from 'contexts/HpaStoreContext';

const ClaimAccount = ({ navigate, workflowType }) => {
    const location = useLocation();
    const history = useHistory();
    const context = useContext(HpaStoreContext);
    const [isLoading, setIsLoading] = useState(false);
    const { email: stateEmail, username: stateUsername, hStreamId, isConfirmed, isProvisioned, firstName, lastName, latestPersonId, mobileNumberExists } = location.state || {};
    const email = stateEmail || stateUsername;

    const onCancelRegister = () => {
        if (workflowType === WORKFLOW_TYPE_LINK_ACCOUNT) {
            history.push({
                pathname: '/account/link',
                search: location.search,
                state: { email: '' },
            });
        } else {
            navigate(registrationSteps.EMAILVALIDATION, { email: '' });
        }
    };

    const onClickContinue = async () => {
        setIsLoading(true);
        try {
            await identityClient.sendRegistrationOTP(
                email,
                hStreamId,
                undefined,
                workflowType,
            );
            const params = new URLSearchParams(location.search);
            const isMobileRequired = isMobileNumberRequiredForLinking(context, params);

            navigate(registrationSteps.VERIFICATIONCODE, {
                email,
                isConfirmed,
                isProvisioned: isProvisioned === true,
                hStreamId,
                firstName,
                lastName,
                latestPersonId,
                workflowType,
                isMobileRequired,
                mobileNumberExists,
            });
        } catch (error) {
            console.error("Error sending OTP:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            className="position-relative"
            aria-busy={isLoading || undefined}
        >
            <BlockingSpinnerOverlay
                show={isLoading}
                ariaLabel="Loading..."
            />
            <p className="AuthWrapper__register__fontsize">
                <div className="pt-1 AuthWrapper__register__wordbreak">{email}</div>
            </p>
            <p className="pt-1">An hStream ID has already been started on your behalf.</p>
            <div className="claim-account__actions">
                <Row className="py-3 d-flex align-items-center">
                    <Col sm="9">
                        <div className="AuthWrapper__register__fontsize font-weight-bold">Let's confirm your identity next</div>
                    </Col>
                    <Col sm="3">
                        <Button id="claimAccount" color="primary" block className="btn btn-sm float-right" onClick={onClickContinue} disabled={isLoading}>
                            {isLoading ? 'Loading...' : 'Continue'}
                        </Button>
                    </Col>
                </Row>
            </div>
            <hr />
            <Button
                id="tryDifferentEmail"
                color="link"
                className="btn btn-sm p-0"
                onClick={onCancelRegister} >
                Try a different email
            </Button>
        </div>
    );
};

ClaimAccount.propTypes = {
    navigate: PropTypes.func.isRequired,
};

export default ClaimAccount;
